import React from 'react';
import { SelectValueComponentProps } from './types';

export const DefaultValueComponent: React.FC<SelectValueComponentProps> = ({ selectedItem }) => (
    <>{selectedItem.text}</>
);
